module.exports = __webpack_public_path__ + "img/broadcast-tiao-icon5.29204ffc.png";